function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M49.735 15.772c0 4.028-1.44 7.925-4.063 10.983l-2.828 3.3a2.503 2.503 0 00-.6 1.625v4.07c0 .69-.56 1.25-1.25 1.25h-1.248m6.243-30.656A13.697 13.697 0 0036 2.036c-7.585 0-13.735 6.15-13.735 13.736 0 4.028 1.441 7.925 4.063 10.983l2.829 3.3c.387.453.6 1.03.6 1.625v4.07c0 .69.56 1.25 1.249 1.25h3.122M29.756 32.005h8.741M36 70.714V53.232",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.828 10.835L33.67 13.51l-1.356 3.133c-.354.818.457 1.655 1.285 1.327l4.8-1.9c.828-.328 1.639.51 1.285 1.327l-1.356 3.134-1.157 2.674M59.725 49.45v11.275c0 .53-.33.983-.796 1.164l-6.696 2.604M12.275 49.449v11.276c0 .528.327.979.79 1.162l2.81 1.093m28.866 4.426l-8.289 3.223c-.14.055-.292.085-.452.085-.161 0-.316-.03-.458-.086l-5.62-2.185-2.809-1.093m-5.619-2.185l1.405.547M59.725 37l-5.931 2.185-5.931 2.185M12.275 37l5.931 2.185m5.931 2.185L36 45.74l5.931-2.185M12.275 37l12.253-4.273M59.725 37l-12.252-4.273",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36 45.74l-9.082 9.6a1.245 1.245 0 01-1.436.274L20.8 53.429m-1.283-27.924L8.109 29.58a1.25 1.25 0 00-.53 1.988L12.276 37 6.28 44.992a1.25 1.25 0 00.472 1.88l9.365 4.371M36 45.74l9.082 9.6a1.245 1.245 0 001.436.274l2.697-1.259m3.269-28.85l11.407 4.075a1.25 1.25 0 01.53 1.988L59.724 37l5.995 7.992a1.25 1.25 0 01-.472 1.88l-10.518 4.91",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/service.svg";
export { SvgService as ReactComponent };